// eslint-disable no-unused-prop-types
import React from 'react'
import { Snackbar as MUISnackbar, Typography } from '@mui/material'
import type { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import HighlightOffIcon from '@mui/icons-material/HighlightOff'

/*
Copyright 2022-06-17 por Alfonso Moya Ecomsur Holding S.A ©
Detalle: se agregan íconoso solicitados por UX/UI
*/

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2)
    }
  },
  error: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignContent: 'center',
    padding: '20px',
    backgroundColor: '#DC0404',
    color: 'white',
    borderRadius: '8px'
  },
  success: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignContent: 'center',
    padding: '20px',
    backgroundColor: '#199D03',
    color: 'white',
    borderRadius: '8px'
  },
  errorrelocate: {
    position: 'fixed',
    bottom: '10vw',
    left: '50%',
    transform: 'translateX(-50%)',
    backgroundColor: '#DC0404',
    color: 'white',
    borderRadius: '8px',
    padding: '16px 24px',
    zIndex: 3000,
    width: '68vw',
    maxWidth: '400px',
    textAlign: 'center',
    boxShadow: '0px 4px 12px rgba(0,0,0,0.2)'
  }
,
  icon: {
    margin: '0px 4px'
  }
}))

interface SnackbarProps {
  open: boolean
  setOpen?: (open: boolean) => void
  message: string
  status: string
  autoHideDuration?: number
}

export const SnackBar: React.FC<SnackbarProps> = ({
  open,
  setOpen,
  message,
  status,
  autoHideDuration = 3000
}) => {
  const classes = useStyles()

  const handleClose = (_event: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return
    }
    setOpen?.(false)
  }

  return (
    <div className={classes.root}>
      <MUISnackbar
        open={open}
        autoHideDuration={autoHideDuration}
        onClose={handleClose}
        style={{ borderRadius: '15px' }}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert message={message} status={status} />
      </MUISnackbar>
    </div>
  )
}

interface AlertProps {
  message: string
  status: string
}

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(({ message, status }, ref) => {
  const classes = useStyles()
  const className = classes[status as keyof ReturnType<typeof useStyles>] ?? classes.error
  return (
    <div ref={ref} className={className}>
      <span className={classes.icon}>
        {status === 'error' && <HighlightOffIcon />}
        {status === 'success' && <CheckCircleOutlineIcon />}
      </span>
      <Typography variant='button'>{message}</Typography>
    </div>
  )
})
